import React, { PropsWithChildren, useEffect, useState } from "react"
import { AppBar, Toolbar, IconButton, Drawer, Box } from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import CloseIcon from "@mui/icons-material/Close"
import { Link, Outlet, useLocation } from "react-router-dom"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../modules/theme/tailwindPalette"
import { USER_REPORTS_ROUTE } from "../../constants/routes"
import FacilitynetLogo from "../../shared/layouts/assets/facilit-net-logo.svg"

const useStyles = makeStyles()(() => ({
    appBar: {
        backgroundColor: tailwindPalette.blue[50],
    },
    logo: {
        width: "auto",
    },
    logoLink: {
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
    },
    pageContainer: {
        padding: "1rem 2rem",
        width: "100%",
    },
    icon: {
        color: "black",
    },
    paper: {
        width: "100%",
        height: "100%",
        paddingTop: "4.5rem", // Padding for AppBar height
        backgroundColor: tailwindPalette.sky[900],
    },
}))

function MobileMenu({ children }: PropsWithChildren) {
    const [open, setOpen] = useState(false)
    const { classes } = useStyles()
    const location = useLocation()

    const toggleDrawer = () => setOpen((prev) => !prev)

    // handle closing the drawer when the route changes rather to pass close prop to nav items
    useEffect(() => {
        setOpen(false)
    }, [location])

    return (
        <>
            <AppBar position="fixed" className={classes.appBar} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    <Link className={classes.logoLink} to={USER_REPORTS_ROUTE}>
                        <img className={classes.logo} src={FacilitynetLogo} alt="Facilitynet" />
                    </Link>
                    <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer}>
                        {open ? <CloseIcon className={classes.icon} /> : <MenuIcon className={classes.icon} />}
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Drawer
                anchor="right"
                open={open}
                onClose={toggleDrawer}
                ModalProps={{
                    keepMounted: true,
                }}
                PaperProps={{
                    className: classes.paper,
                }}
            >
                {children}
            </Drawer>
            <Box className={classes.pageContainer}>
                <Outlet />
            </Box>
        </>
    )
}

export { MobileMenu }
